import { FadeUp } from "./Reveal";

const STEPS = [
        {
                n: "1",
                title: "A 45-minute discovery call",
                desc: "We learn how you run and where the silos hurt.",
        },
        {
                n: "2",
                title: "Choose your first journey",
                desc: "One journey, one KPI, agreed success metrics.",
        },
        {
                n: "3",
                title: "Sign and start",
                desc: "Kick-off within weeks; the Canvas live in your first month.",
        },
];

export default function JoinCta() {
        return (
                <section id="join" data-testid="join-section" className="relative py-16 md:py-24 border-t border-[var(--border-line)] overflow-hidden">
                        <div className="max-container">
                                <FadeUp>
                                        <div className="step-eyebrow mb-5">Join Cohort 1</div>
                                </FadeUp>
                                <FadeUp delay={0.06}>
                                        <h2 className="h2x text-[11vw] md:text-[6.2vw] leading-[1.02] max-w-[14ch] mb-6">
                                                Are you a <span className="acc">Super</span> Company?
                                        </h2>
                                </FadeUp>
                                <FadeUp delay={0.12}>
                                        <p className="text-lg md:text-2xl text-[var(--bone-dim)] max-w-[46ch] mb-12 md:mb-16">
                                                Take the open seat in Cohort 1.
                                        </p>
                                </FadeUp>

                                <div className="grid grid-cols-12 gap-6 items-start">
                                        <FadeUp delay={0.16} className="col-span-12 lg:col-span-8">
                                                <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-[var(--bone-dim)] mb-6">
                                                        Three steps to your seat
                                                </div>
                                                <div className="border-t border-l border-[var(--border-line)] grid grid-cols-1 md:grid-cols-3">
                                                        {STEPS.map((s) => (
                                                                <div key={s.n} className="border-r border-b border-[var(--border-line)] p-6">
                                                                        <div
                                                                                className="w-9 h-9 rounded-full flex items-center justify-center font-mono text-sm text-white mb-5"
                                                                                style={{ background: "var(--accent-green)" }}
                                                                        >
                                                                                {s.n}
                                                                        </div>
                                                                        <div className="font-display font-bold tracking-tight mb-2">{s.title}</div>
                                                                        <p className="text-sm text-[var(--bone-dim)] leading-relaxed">{s.desc}</p>
                                                                </div>
                                                        ))}
                                                </div>
                                                <div className="mt-8 flex flex-wrap items-center gap-3">
                                                        <a
                                                                href="/apply"
                                                                data-testid="join-apply-cta"
                                                                className="pill-btn"
                                                                style={{ background: "var(--accent-green)", borderColor: "var(--accent-green)", color: "#fff" }}
                                                        >
                                                                Apply for Cohort 1 →
                                                        </a>
                                                        <a href="mailto:ansar.k@natant.ai" className="pill-btn pill-btn--ghost" data-testid="join-contact-cta">
                                                                Talk to the founder
                                                        </a>
                                                </div>
                                        </FadeUp>

                                        <FadeUp delay={0.22} className="col-span-12 lg:col-span-4">
                                                <div className="border border-[var(--border-line)] rounded-2xl bg-[var(--surface)] p-6 md:p-8">
                                                        <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-[var(--bone-dim)] mb-4">Your host</div>
                                                        <div className="font-display font-bold text-xl tracking-tight">Ansar Kanhiroli</div>
                                                        <div className="text-sm text-[var(--bone-dim)] mb-5">Founder &amp; CEO</div>
                                                        <div className="space-y-2 text-sm">
                                                                <a href="mailto:ansar.k@natant.ai" className="block acc hover:opacity-70 transition-opacity">
                                                                        ansar.k@natant.ai
                                                                </a>
                                                                <span className="block text-[var(--bone-dim)]">natant.ai</span>
                                                        </div>
                                                </div>
                                        </FadeUp>
                                </div>
                        </div>
                </section>
        );
}
